export enum InitialsTheme {
  Light,
  Dark
}
